import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { setUserContext, clearUserContext } from '../config/sentry';

/**
 * Hook to automatically track user context in Sentry
 * Watches Redux auth state and updates Sentry user context accordingly
 */
export const useSentryUser = () => {
  const user = useSelector((state) => state.auth?.user);
  const session = useSelector((state) => state.auth?.session);

  useEffect(() => {
    if (user && session) {
      // User is logged in - set user context
      setUserContext(user);
    } else {
      // User is logged out - clear user context
      clearUserContext();
    }
  }, [user, session]);

  return null; // This hook doesn't return anything
};

